import { defineComponent as N, computed as O, openBlock as y, createBlock as G, unref as t, withCtx as d, createTextVNode as S, toDisplayString as $, ref as D, createElementBlock as L, createElementVNode as v, createVNode as l, createCommentVNode as z, renderSlot as oa, withAsyncContext as H, reactive as W, onMounted as Y, Fragment as ia, renderList as ra } from "vue";
import { useI18n as C } from "vue-i18n";
import { MpText as K, MpAccordion as va, useMpScreen as U, MpCard as F, MpNumber as J, MpSelect as Q, MpRadio as na, MpButton as Z, MpDivider as X } from "@borg/ui";
const ha = {
  form: {
    amount: "Amount",
    place: "Place of residence (tax rates)",
    children: "Number of children",
    dependents: "Number of dependents",
    net_to_gross: "Net > Gross",
    gross_to_net: "Gross > Net",
    disability_none: "No disability",
    disability_partial: "Partial disability",
    disability_full: "100% disability",
    author_regular: "Copyright contract",
    author_artist: "Copyright contract of the artist",
    avg_gross_amount: "Average of the last three gross salaries*",
    gross_salary: "Total gross salary",
    calculate: "Do the math",
    detailed_calculate: "Detailed calculation",
    gross: "Gross",
    gross_is_calculation_amount: "(Gross 1) is the amount on which pension, taxes and surcharge are calculated",
    net: "Net",
    net_is_final_amount: "is the final amount paid to the employee's account, after all obligations to the state have been settled"
  },
  result: {
    salary_gross: "Gross salary",
    salary_net: "Net salary",
    gross_1: "Gross",
    net: "Net",
    pension_1: "I. column of pension insurance",
    pension_1_more: "The first pillar of pension insurance is a contribution based on generational solidarity, it is used to finance the pensions of current retirees.",
    pension_2: "II. ",
    pension_2_more: "II. ",
    gross_contribution: "Total contributions from gross",
    pension_contribution: "Total pension contribution",
    exemption: "Personal deduction",
    exemption_more: "Personal deduction is a reduction of the tax base (e.g. based on the number of children, number of dependents...).",
    taxable_amount: "Tax base",
    taxable_amount_more: "The tax base is the gross amount less I. and II. ",
    tax: "Income tax",
    tax_more: "Income tax is the amount with which the income of natural and legal persons is taxed. ",
    surtax: "Surtax",
    surtax_more: "The surtax is paid on the income tax at the rate determined according to the city decisions of cities and municipalities.",
    tax_and_surtax: "Sum of taxes and surcharges",
    gross_2: "Total salary cost for the employer",
    gross_2_more: "The total salary cost for the employer is the gross amount increased by the contribution for health insurance.",
    health_insurance: "Contribution for health insurance",
    salary_contribution: "Total contributions to gross",
    gross_amount: "Gross amount",
    expense: "Outlay",
    expense_more: "The flat rate is 30% of the gross amount for royalties and an additional 25% for artist's royalties.",
    contribution_base: "Basis for calculation of contributions",
    tax_base: "Tax base",
    total_expense: "The total cost of the payer",
    total_expense_more: "The total cost of compensation for the payer is the gross amount increased by the contribution for health insurance.",
    amount_net: "Net amount",
    pdf_download: "Download the PDF",
    taxable: "Taxable",
    non_taxable: "Tax free",
    salary_amount_net: "Net salary amount",
    salary: "Salary",
    income: "Income (gross salary - contributions)",
    tax_total: "Income tax - total",
    tax_lower: "20% (0 - HRK 30,000)",
    tax_higher: "30% (> HRK 30,000)",
    total: "In total",
    details_title: "Detailed calculation",
    details_warning: "Note: the detailed calculation of the calculator is informative."
  }
}, q = {
  mp_calculator_croatia: ha
}, ba = {
  form: {
    amount: "Iznos",
    place: "Mjesto prebivališta (stope poreza)",
    children: "Broj djece",
    dependents: "Broj uzdržavanih osoba",
    net_to_gross: "Netto > Brutto",
    gross_to_net: "Brutto > Netto",
    disability_none: "Bez invalidnosti",
    disability_partial: "Djelomična invalidnost",
    disability_full: "100% invalidnost",
    author_regular: "Autorski ugovor",
    author_artist: "Autorski ugovor umjetnika",
    avg_gross_amount: "Prosjek tri zadnje bruto plaće*",
    gross_salary: "Ukupna bruto plaća",
    calculate: "Izračunaj",
    detailed_calculate: "Detaljan izračun",
    gross: "Bruto",
    gross_is_calculation_amount: "(Bruto 1) je iznos na koji se obračunava mirovinsko, porezi i prirez",
    net: "Neto",
    net_is_final_amount: "je konačan iznos koji se isplaćuje zaposleniku na račun, nakon što se podmire sve obveze prema državi"
  },
  result: {
    salary_gross: "Bruto plaća",
    salary_net: "Neto plaća",
    gross_1: "Bruto",
    net: "Neto",
    pension_1: "I. stup mirovinskog osiguranja",
    pension_1_more: "I. stup mirovinskog osiguranja je doprinos na temelju generacijske solidarnosti, njime se financiraju mirovine sadašnjih umirovljenika.",
    pension_2: "II. stup mirovinskog osiguranja",
    pension_2_more: "II. stup mirovinsko osiguranje je doprinos na temelju individualne kapitalizirane štednje i odnosi se na štednju za buduće mirovine.",
    gross_contribution: "Ukupno doprinosi iz bruta",
    pension_contribution: "Ukupni doprinos za mirovinsko",
    exemption: "Osobni odbitak",
    exemption_more: "Osobni odbitak je smanjenje porezne osnovice (npr. na temelju broja djece, broja uzdržavanih osoba...).",
    taxable_amount: "Porezna osnovica",
    taxable_amount_more: "Porezna osnovica je bruto iznos umanjen za I. i II. stup mirovinskog osiguranja i osobni odbitak.",
    tax: "Porez na dohodak",
    tax_more: "Porez na dohodak je iznos kojim se oporezuje dohodak fizičkih i pravnih osoba. Stope poreza utvrđene su prema Zakonu o porezu na dohodak. Dohodak do iznosa od 5.000 eura oporezuje se po prvoj (nižoj) stopi poreza na dohodak, dok se iznos koji prelazi navedeni prag oporezuje po drugoj (višoj) poreznoj stopi.",
    surtax: "Prirez",
    surtax_more: "Prirez se plaća na porez na dohodak po stopi koja je utvrđena prema gradskim odlukama gradova odnosno općina.",
    tax_and_surtax: "Zbroj poreza i prireza",
    gross_2: "Ukupan trošak plaće za poslodavca",
    gross_2_more: "Ukupan trošak plaće za poslodavca je bruto iznos uvećan za doprinos za zdravstveno osiguranje.",
    health_insurance: "Doprinos za zdravstveno osiguranje",
    salary_contribution: "Ukupno doprinosi na bruto",
    gross_amount: "Bruto iznos",
    expense: "Izdatak",
    expense_more: "Paušalni izdatak je 30% bruto iznosa za autorski honorar i dodatnih 25% za autorski honorar umjetnika.",
    contribution_base: "Osnovica za obračun doprinosa",
    tax_base: "Porezna osnovica",
    total_expense: "Ukupni trošak isplatitelja",
    total_expense_more: "Ukupan trošak naknade za isplatitelja je bruto iznos uvećan za doprinos za zdravstveno osiguranje.",
    amount_net: "Neto iznos",
    pdf_download: "Preuzmi PDF",
    taxable: "Oporezivo",
    non_taxable: "Neoporezivo",
    salary_amount_net: "Neto iznos plaće",
    salary: "Plaća",
    income: "Dohodak (bruto plaća - doprinosi)",
    tax_total: "Porez na dohodak - ukupno",
    tax_lower: "20% (0 - 30000kn)",
    tax_higher: "30% ( > 30000kn)",
    total: "Ukupno",
    details_title: "Detaljni izračun",
    details_warning: "Napomena: detaljni izračun kalkulatora je informativnog karaktera."
  }
}, aa = {
  mp_calculator_croatia: ba
}, Ra = [
  {
    value: 19,
    label: "Andrijaševci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 27,
    label: "Antunovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 35,
    label: "Babina Greda",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 43,
    label: "Bakar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 51,
    label: "Bale - Valle",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 60,
    label: "Barban",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 78,
    label: "Barilović",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 86,
    label: "Baška",
    lowRate: 0.15,
    highRate: 0.25
  },
  {
    value: 94,
    label: "Baška Voda",
    lowRate: 0.17,
    highRate: 0.27
  },
  {
    value: 108,
    label: "Bebrina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 116,
    label: "Bedekovčina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5509,
    label: "Bedenica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 124,
    label: "Bednja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 132,
    label: "Beli Manastir",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 159,
    label: "Belica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 167,
    label: "Belišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 175,
    label: "Benkovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 183,
    label: "Berek",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 191,
    label: "Beretinec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 205,
    label: "Bibinje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6211,
    label: "Bilice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 213,
    label: "Bilje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 221,
    label: "Biograd na Moru",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3107,
    label: "Biskupija",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5479,
    label: "Bistra",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 230,
    label: "Bizovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 248,
    label: "Bjelovar",
    lowRate: 0.18,
    highRate: 0.25
  },
  {
    value: 256,
    label: "Blato",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 264,
    label: "Bogdanovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 272,
    label: "Bol",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 299,
    label: "Borovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 302,
    label: "Bosiljevo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 329,
    label: "Bošnjaci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 337,
    label: "Brckovljani",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 345,
    label: "Brdovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 779,
    label: "Brela",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 353,
    label: "Brestovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 361,
    label: "Breznica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1511,
    label: "Breznički Hum",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 370,
    label: "Brinje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 388,
    label: "Brod Moravice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 396,
    label: "Brodski Stupnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 400,
    label: "Brtonigla - Verteneglio",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 418,
    label: "Budinščina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 426,
    label: "Buje - Buie",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5673,
    label: "Bukovlje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 434,
    label: "Buzet",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 442,
    label: "Cerna",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 469,
    label: "Cernik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 477,
    label: "Cerovlje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 485,
    label: "Cestica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 493,
    label: "Cetingrad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 507,
    label: "Cista Provo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 515,
    label: "Civljane",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 523,
    label: "Cres",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 531,
    label: "Crikvenica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 540,
    label: "Crnac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 558,
    label: "Čabar",
    lowRate: 0.19,
    highRate: 0.3
  },
  {
    value: 566,
    label: "Čačinci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 574,
    label: "Čađavica",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 582,
    label: "Čaglin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 604,
    label: "Čakovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 612,
    label: "Čavle",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 639,
    label: "Čazma",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 647,
    label: "Čeminac",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 655,
    label: "Čepin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 663,
    label: "Darda",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 671,
    label: "Daruvar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 680,
    label: "Davor",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6033,
    label: "Dekanovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 698,
    label: "Delnice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 701,
    label: "Desinić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 710,
    label: "Dežanovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 728,
    label: "Dicmo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 744,
    label: "Dobrinj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 752,
    label: "Domašinec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 787,
    label: "Donja Dubrava",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5762,
    label: "Donja Motičina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 795,
    label: "Donja Stubica",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 809,
    label: "Donja Voća",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 817,
    label: "Donji Andrijevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 825,
    label: "Donji Kraljevec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 833,
    label: "Donji Kukuruzari",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 841,
    label: "Donji Lapac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 868,
    label: "Donji Miholjac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 892,
    label: "Donji Vidovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5681,
    label: "Dragalić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 906,
    label: "Draganić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 914,
    label: "Draž",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 922,
    label: "Drenovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 949,
    label: "Drenje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 957,
    label: "Drniš",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 965,
    label: "Drnje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 973,
    label: "Dubrava",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5495,
    label: "Dubravica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5983,
    label: "Dubrovačko Primorje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 981,
    label: "Dubrovnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 990,
    label: "Duga Resa",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 1007,
    label: "Dugi Rat",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1015,
    label: "Dugo Selo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5851,
    label: "Dugopolje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1023,
    label: "Dvor",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1031,
    label: "Đakovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1040,
    label: "Đelekovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1058,
    label: "Đulovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1066,
    label: "Đurđenovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1074,
    label: "Đurđevac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1082,
    label: "Đurmanec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1104,
    label: "Erdut",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1112,
    label: "Ernestinovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1139,
    label: "Ervenik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1147,
    label: "Farkaševac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6190,
    label: "Fažana - Fasana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1155,
    label: "Ferdinandovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1163,
    label: "Feričanci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6297,
    label: "Funtana - Fontane",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1171,
    label: "Fužine",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5711,
    label: "Galovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1180,
    label: "Garčin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1198,
    label: "Garešnica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1201,
    label: "Generalski Stol",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1210,
    label: "Glina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1228,
    label: "Gola",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1236,
    label: "Goričan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1244,
    label: "Gorjani",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6181,
    label: "Gornja Rijeka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1252,
    label: "Gornja Stubica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5690,
    label: "Gornja Vrba",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1279,
    label: "Gornji Bogićevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1295,
    label: "Gornji Kneginec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6041,
    label: "Gornji Mihaljevec",
    lowRate: 0.17,
    highRate: 0.27
  },
  {
    value: 1309,
    label: "Gospić",
    lowRate: 0.22,
    highRate: 0.32
  },
  {
    value: 1317,
    label: "Gračac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1325,
    label: "Gračišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1341,
    label: "Gradac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1350,
    label: "Gradec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1368,
    label: "Gradina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1376,
    label: "Gradište",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1384,
    label: "Grožnjan - Grisignana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1392,
    label: "Grubišno Polje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1406,
    label: "Gundinci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1414,
    label: "Gunja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5100,
    label: "Gvozd",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1449,
    label: "Hercegovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1457,
    label: "Hlebine",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1465,
    label: "Hrašćina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1481,
    label: "Hrvace",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1490,
    label: "Hrvatska Dubica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1503,
    label: "Hrvatska Kostajnica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1520,
    label: "Hum Na Sutli",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1538,
    label: "Hvar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1546,
    label: "Ilok",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1554,
    label: "Imotski",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 1562,
    label: "Ivanec",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 1589,
    label: "Ivanić-Grad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1597,
    label: "Ivankovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1619,
    label: "Ivanska",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6092,
    label: "Jagodnjak",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1635,
    label: "Jakovlje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1643,
    label: "Jakšić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1651,
    label: "Jalžabet",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5991,
    label: "Janjina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1660,
    label: "Jarmina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1678,
    label: "Jasenice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1686,
    label: "Jasenovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1694,
    label: "Jastrebarsko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1708,
    label: "Jelenje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1716,
    label: "Jelsa",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5525,
    label: "Jesenje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1724,
    label: "Josipdol",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1732,
    label: "Kali",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5592,
    label: "Kalinovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5606,
    label: "Kalnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6238,
    label: "Kamanje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1759,
    label: "Kanfanar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1767,
    label: "Kapela",
    lowRate: 0.15,
    highRate: 0.25
  },
  {
    value: 1775,
    label: "Kaptol",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1783,
    label: "Karlobag",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1791,
    label: "Karlovac",
    lowRate: 0.19,
    highRate: 0.29
  },
  {
    value: 5967,
    label: "Karojba",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1805,
    label: "Kastav",
    lowRate: 0.2,
    highRate: 0.31
  },
  {
    value: 1813,
    label: "Kaštela",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5975,
    label: "Kaštelir-Labinci - Castelliere-S. Domenica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1830,
    label: "Kijevo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1848,
    label: "Kistanje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1856,
    label: "Klakar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1864,
    label: "Klana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1872,
    label: "Klanjec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1899,
    label: "Klenovnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1902,
    label: "Klinča Sela",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1929,
    label: "Klis",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1937,
    label: "Kloštar Ivanić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1945,
    label: "Kloštar Podravski",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1953,
    label: "Kneževi Vinogradi",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1961,
    label: "Knin",
    lowRate: 0.21,
    highRate: 0.32
  },
  {
    value: 6220,
    label: "Kolan",
    lowRate: 0.15,
    highRate: 0.25
  },
  {
    value: 1970,
    label: "Komiža",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1988,
    label: "Konavle",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1996,
    label: "Končanica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2003,
    label: "Konjščina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2011,
    label: "Koprivnica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2020,
    label: "Koprivnički Bregi",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2038,
    label: "Koprivnički Ivanec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2046,
    label: "Korčula",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5380,
    label: "Kostrena",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2054,
    label: "Koška",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2062,
    label: "Kotoriba",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2089,
    label: "Kraljevec Na Sutli",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2097,
    label: "Kraljevica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2119,
    label: "Krapina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2127,
    label: "Krapinske Toplice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5339,
    label: "Krašić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5452,
    label: "Kravarsko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2135,
    label: "Križ",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2143,
    label: "Križevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2151,
    label: "Krk",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2160,
    label: "Krnjak",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2178,
    label: "Kršan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5720,
    label: "Kukljica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2194,
    label: "Kula Norinska",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5533,
    label: "Kumrovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2208,
    label: "Kutina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2216,
    label: "Kutjevo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2224,
    label: "Labin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2232,
    label: "Lanišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2259,
    label: "Lasinja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2267,
    label: "Lastovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5860,
    label: "Lećevica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2275,
    label: "Legrad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2283,
    label: "Lekenik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2291,
    label: "Lepoglava",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 2305,
    label: "Levanjska Varoš",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2313,
    label: "Lipik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2321,
    label: "Lipovljani",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2348,
    label: "Lišane Ostrovičke",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2356,
    label: "Ližnjan - Lisignano",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2364,
    label: "Lobor",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2372,
    label: "Lokve",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5878,
    label: "Lokvičići",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6246,
    label: "Lopar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2399,
    label: "Lovas",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2402,
    label: "Lovinac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2429,
    label: "Lovran",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2437,
    label: "Lovreć",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2445,
    label: "Ludbreg",
    lowRate: 0.2,
    highRate: 0.31
  },
  {
    value: 5487,
    label: "Luka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2453,
    label: "Lukač",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6009,
    label: "Lumbarda",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2461,
    label: "Lupoglav",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2470,
    label: "Ljubešćica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2488,
    label: "Mače",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5789,
    label: "Magadenovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5550,
    label: "Majur",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2496,
    label: "Makarska",
    lowRate: 0.18,
    highRate: 0.31
  },
  {
    value: 2500,
    label: "Mala Subotica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2518,
    label: "Mali Bukovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2526,
    label: "Mali Lošinj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2534,
    label: "Malinska-Dubašnica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2542,
    label: "Marčana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2569,
    label: "Marija Bistrica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5398,
    label: "Marija Gorica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2577,
    label: "Marijanci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2585,
    label: "Marina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6106,
    label: "Markušica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 850,
    label: "Martijanec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2593,
    label: "Martinska Ves",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2607,
    label: "Maruševec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2615,
    label: "Matulji",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2631,
    label: "Medulin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2640,
    label: "Metković",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2658,
    label: "Mihovljan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2666,
    label: "Mikleuš",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2674,
    label: "Milna",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2682,
    label: "Mljet",
    lowRate: 0.2,
    highRate: 0.27
  },
  {
    value: 2704,
    label: "Molve",
    lowRate: 0.15,
    highRate: 0.25
  },
  {
    value: 2739,
    label: "Mošćenička Draga",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2747,
    label: "Motovun - Montona",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2755,
    label: "Mrkopalj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 876,
    label: "Muć",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2763,
    label: "Mursko Središće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6173,
    label: "Murter - Kornati",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2780,
    label: "Našice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2798,
    label: "Nedelišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6122,
    label: "Negoslavci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2801,
    label: "Nerežišća",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2810,
    label: "Netretić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2950,
    label: "Nijemci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2828,
    label: "Nin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2836,
    label: "Nova Bukovica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2844,
    label: "Nova Gradiška",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 2852,
    label: "Nova Kapela",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2879,
    label: "Nova Rača",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2887,
    label: "Novalja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5541,
    label: "Novi Golubovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2895,
    label: "Novi Marof",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2909,
    label: "Novi Vinodolski",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5371,
    label: "Novigrad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2917,
    label: "Novigrad - Cittanova",
    lowRate: 0.2,
    highRate: 0.31
  },
  {
    value: 2925,
    label: "Novigrad Podravski",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5614,
    label: "Novo Virje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2933,
    label: "Novska",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2941,
    label: "Nuštar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2968,
    label: "Obrovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2976,
    label: "Ogulin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5886,
    label: "Okrug",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2992,
    label: "Okučani",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3e3,
    label: "Omiš",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 3018,
    label: "Omišalj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3026,
    label: "Opatija",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3034,
    label: "Oprisavci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3042,
    label: "Oprtalj - Portole",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3069,
    label: "Opuzen",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3077,
    label: "Orahovica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3085,
    label: "Orebić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6050,
    label: "Orehovica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3093,
    label: "Oriovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5428,
    label: "Orle",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3115,
    label: "Oroslavje*",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3123,
    label: "Osijek",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3131,
    label: "Otočac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3140,
    label: "Otok",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5355,
    label: "Otok",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3158,
    label: "Ozalj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3166,
    label: "Pag",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3174,
    label: "Pakoštane",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3182,
    label: "Pakrac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3204,
    label: "Pašman",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3212,
    label: "Pazin",
    lowRate: 0.22,
    highRate: 0.3
  },
  {
    value: 3239,
    label: "Perušić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3247,
    label: "Peteranec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3255,
    label: "Petlovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3263,
    label: "Petrijanec",
    lowRate: 0.2,
    highRate: 0.27
  },
  {
    value: 3271,
    label: "Petrijevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3280,
    label: "Petrinja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3298,
    label: "Petrovsko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3301,
    label: "Pićan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5819,
    label: "Pirovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3310,
    label: "Pisarovina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3328,
    label: "Pitomača",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3336,
    label: "Plaški",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3344,
    label: "Pleternica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4553,
    label: "Plitvička Jezera",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3352,
    label: "Ploče",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3379,
    label: "Podbablje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3387,
    label: "Podcrkavlje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3395,
    label: "Podgora",
    lowRate: 0.18,
    highRate: 0.3
  },
  {
    value: 3409,
    label: "Podgorač",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2712,
    label: "Podravska Moslavina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6165,
    label: "Podravske Sesvete",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3417,
    label: "Podstrana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3425,
    label: "Podturen",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3433,
    label: "Pojezerje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5444,
    label: "Pokupsko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3441,
    label: "Polača",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3450,
    label: "Poličnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3468,
    label: "Popovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3476,
    label: "Popovača",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3484,
    label: "Poreč - Parenzo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3492,
    label: "Posedarje",
    lowRate: 0.18,
    highRate: 0.3
  },
  {
    value: 3506,
    label: "Postira",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5738,
    label: "Povljana",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3514,
    label: "Požega",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3522,
    label: "Pregrada",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 3549,
    label: "Preko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3557,
    label: "Prelog",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3565,
    label: "Preseka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5894,
    label: "Prgomet",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6203,
    label: "Pribislavec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5908,
    label: "Primorski Dolac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3573,
    label: "Primošten",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5835,
    label: "Privlaka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5746,
    label: "Privlaka",
    lowRate: 0.17,
    highRate: 0.3
  },
  {
    value: 884,
    label: "Proložac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 2984,
    label: "Promina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3581,
    label: "Pučišća",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3590,
    label: "Pula - Pola",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 3603,
    label: "Punat",
    lowRate: 0.15,
    highRate: 0.3
  },
  {
    value: 3611,
    label: "Punitovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3620,
    label: "Pušća",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3638,
    label: "Rab",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3646,
    label: "Radoboj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5363,
    label: "Rakovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3654,
    label: "Rakovica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3662,
    label: "Rasinja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3689,
    label: "Raša",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3697,
    label: "Ravna Gora",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3719,
    label: "Ražanac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3727,
    label: "Rešetari",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5568,
    label: "Ribnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3735,
    label: "Rijeka",
    lowRate: 0.22,
    highRate: 0.32
  },
  {
    value: 5827,
    label: "Rogoznica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3743,
    label: "Rovinj - Rovigno",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3751,
    label: "Rovišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3760,
    label: "Rugvica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5916,
    label: "Runovići",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3778,
    label: "Ružić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3786,
    label: "Saborsko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3794,
    label: "Sali",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3808,
    label: "Samobor",
    lowRate: 0.18,
    highRate: 0.27
  },
  {
    value: 3816,
    label: "Satnica Đakovačka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3824,
    label: "Seget",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3832,
    label: "Selca",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3859,
    label: "Selnica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3867,
    label: "Semeljci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3875,
    label: "Senj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5622,
    label: "Severin",
    lowRate: 0.18,
    highRate: 0.28
  },
  {
    value: 3883,
    label: "Sibinj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5703,
    label: "Sikirevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3891,
    label: "Sinj",
    lowRate: 0.18,
    highRate: 0.3
  },
  {
    value: 3905,
    label: "Sirač",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3913,
    label: "Sisak",
    lowRate: 0.216,
    highRate: 0.316
  },
  {
    value: 3930,
    label: "Skrad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3948,
    label: "Skradin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3956,
    label: "Slatina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3964,
    label: "Slavonski Brod",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3972,
    label: "Slavonski Šamac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 3999,
    label: "Slivno",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4006,
    label: "Slunj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4022,
    label: "Smokvica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4057,
    label: "Sokolovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4065,
    label: "Solin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4073,
    label: "Sopje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4090,
    label: "Split",
    lowRate: 0.215,
    highRate: 0.32
  },
  {
    value: 4103,
    label: "Sračinec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4111,
    label: "Stankovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4120,
    label: "Stara Gradiška",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4138,
    label: "Stari Grad",
    lowRate: 0.2,
    highRate: 0.31
  },
  {
    value: 4146,
    label: "Stari Jankovci",
    lowRate: 0.15,
    highRate: 0.25
  },
  {
    value: 4154,
    label: "Stari Mikanovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4162,
    label: "Starigrad",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4189,
    label: "Staro Petrovo Selo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4197,
    label: "Ston",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6068,
    label: "Strahoninec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4219,
    label: "Strizivojna",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4227,
    label: "Stubičke Toplice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5517,
    label: "Stupnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4235,
    label: "Sućuraj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4243,
    label: "Suhopolje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4251,
    label: "Sukošan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4260,
    label: "Sunja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4278,
    label: "Supetar",
    lowRate: 0.205,
    highRate: 0.31
  },
  {
    value: 5924,
    label: "Sutivan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6076,
    label: "Sveta Marija",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4324,
    label: "Sveta Nedelja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4367,
    label: "Sveta Nedelja",
    lowRate: 0.18,
    highRate: 0.28
  },
  {
    value: 4375,
    label: "Sveti Đurđ",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4286,
    label: "Sveti Filip i Jakov",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4383,
    label: "Sveti Ilija",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4294,
    label: "Sveti Ivan Zelina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4391,
    label: "Sveti Ivan Žabno",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4405,
    label: "Sveti Juraj na Bregu",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4308,
    label: "Sveti Križ Začretje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4316,
    label: "Sveti Lovreč",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4413,
    label: "Sveti Martin na Muri",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4421,
    label: "Sveti Petar Orehovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4332,
    label: "Sveti Petar u Šumi",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4359,
    label: "Svetvinčenat",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5649,
    label: "Šandrovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6084,
    label: "Šenkovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4430,
    label: "Šestanovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4448,
    label: "Šibenik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4456,
    label: "Škabrnja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6149,
    label: "Šodolovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4472,
    label: "Šolta",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4499,
    label: "Špišić Bukovica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4502,
    label: "Štefanje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6289,
    label: "Štitar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4529,
    label: "Štrigova",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6319,
    label: "Tar-Vabriga - Torre-Abrega",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4537,
    label: "Tinjan",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4545,
    label: "Tisno",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5754,
    label: "Tkon",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4561,
    label: "Tompojevci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4570,
    label: "Topusko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4588,
    label: "Tordinci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5576,
    label: "Tounj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4596,
    label: "Tovarnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6262,
    label: "Tribunj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4600,
    label: "Trilj",
    lowRate: 0.15,
    highRate: 0.3
  },
  {
    value: 4618,
    label: "Trnava",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4626,
    label: "Trnovec Bartolovečki",
    lowRate: 0.18,
    highRate: 0.3
  },
  {
    value: 4634,
    label: "Trogir",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 6017,
    label: "Trpanj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4642,
    label: "Trpinja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5932,
    label: "Tučepi",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4669,
    label: "Tuhelj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4677,
    label: "Udbina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4685,
    label: "Umag - Umago",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4693,
    label: "Unešić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4715,
    label: "Valpovo",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 4723,
    label: "Varaždin",
    lowRate: 0.21,
    highRate: 0.32
  },
  {
    value: 4731,
    label: "Varaždinske Toplice",
    lowRate: 0.21,
    highRate: 0.3
  },
  {
    value: 4740,
    label: "Vela Luka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4758,
    label: "Velika",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5410,
    label: "Velika Gorica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4766,
    label: "Velika Kopanica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4774,
    label: "Velika Ludina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4782,
    label: "Velika Pisanica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5657,
    label: "Velika Trnovitica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5584,
    label: "Veliki Bukovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4804,
    label: "Veliki Grđevac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4812,
    label: "Veliko Trgovišće",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4839,
    label: "Veliko Trojstvo",
    lowRate: 0.175,
    highRate: 0.275
  },
  {
    value: 4847,
    label: "Vidovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4855,
    label: "Viljevo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4863,
    label: "Vinica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4871,
    label: "Vinkovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4880,
    label: "Vinodolska Općina",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4898,
    label: "Vir",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4901,
    label: "Virje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4910,
    label: "Virovitica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4928,
    label: "Vis",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4936,
    label: "Visoko",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4944,
    label: "Viškovci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4952,
    label: "Viškovo",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4979,
    label: "Višnjan - Visignano",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 4987,
    label: "Vižinada - Visinada",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5797,
    label: "Vladislavci",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 4995,
    label: "Voćin",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5002,
    label: "Vodice",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5029,
    label: "Vodnjan - Dignano",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5843,
    label: "Vođinci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5037,
    label: "Vojnić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5045,
    label: "Vratišinec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5053,
    label: "Vrbanja",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5061,
    label: "Vrbje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5070,
    label: "Vrbnik",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5088,
    label: "Vrbovec",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5096,
    label: "Vrbovsko",
    lowRate: 0.21,
    highRate: 0.31
  },
  {
    value: 5118,
    label: "Vrgorac",
    lowRate: 0.21,
    highRate: 0.25
  },
  {
    value: 5126,
    label: "Vrhovine",
    lowRate: 0.18,
    highRate: 0.3
  },
  {
    value: 5134,
    label: "Vrlika",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5142,
    label: "Vrpolje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5169,
    label: "Vrsar - Orsera",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6254,
    label: "Vrsi",
    lowRate: 0.15,
    highRate: 0.3
  },
  {
    value: 5177,
    label: "Vuka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5185,
    label: "Vukovar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5193,
    label: "Zabok",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5207,
    label: "Zadar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5959,
    label: "Zadvarje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5215,
    label: "Zagorska Sela",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 1333,
    label: "Zagreb",
    lowRate: 0.23,
    highRate: 0.33
  },
  {
    value: 5223,
    label: "Zagvozd",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5436,
    label: "Zaprešić",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5231,
    label: "Zažablje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5240,
    label: "Zdenci",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5258,
    label: "Zemunik Donji",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5266,
    label: "Zlatar",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5274,
    label: "Zlatar Bistrica",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5282,
    label: "Zmijavci",
    lowRate: 0.2,
    highRate: 0.25
  },
  {
    value: 5665,
    label: "Zrinski Topolovac",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5304,
    label: "Žakanje",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5312,
    label: "Žminj",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5401,
    label: "Žumberak",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 6025,
    label: "Župa Dubrovačka",
    lowRate: 0.2,
    highRate: 0.3
  },
  {
    value: 5347,
    label: "Županja",
    lowRate: 0.21,
    highRate: 0.31
  }
], ca = [
  {
    value: 1,
    label: "Andrijaševci",
    surtax: 8
  },
  {
    value: 303,
    label: "Antunovac",
    surtax: 0
  },
  {
    value: 309,
    label: "Babina Greda",
    surtax: 5
  },
  {
    value: 2,
    label: "Bale",
    surtax: 1
  },
  {
    value: 3,
    label: "Barban",
    surtax: 5
  },
  {
    value: 4,
    label: "Bedenica",
    surtax: 3
  },
  {
    value: 5,
    label: "Bednja",
    surtax: 10
  },
  {
    value: 6,
    label: "Beli Manastir",
    surtax: 5
  },
  {
    value: 7,
    label: "Belica",
    surtax: 0
  },
  {
    value: 8,
    label: "Belišće",
    surtax: 7
  },
  {
    value: 9,
    label: "Benkovac",
    surtax: 5
  },
  {
    value: 10,
    label: "Beretinec",
    surtax: 7
  },
  {
    value: 11,
    label: "Bilice",
    surtax: 10
  },
  {
    value: 12,
    label: "Bilje",
    surtax: 5
  },
  {
    value: 316,
    label: "Biograd na moru",
    surtax: 12
  },
  {
    value: 13,
    label: "Biskupija",
    surtax: 4
  },
  {
    value: 14,
    label: "Bistra",
    surtax: 10
  },
  {
    value: 15,
    label: "Bizovac",
    surtax: 3
  },
  {
    value: 16,
    label: "Bjelovar",
    surtax: 0
  },
  {
    value: 17,
    label: "Blato",
    surtax: 10
  },
  {
    value: 18,
    label: "Bol",
    surtax: 10
  },
  {
    value: 19,
    label: "Borovo",
    surtax: 6
  },
  {
    value: 20,
    label: "Bošnjaci",
    surtax: 0
  },
  {
    value: 21,
    label: "Brckovljani",
    surtax: 3
  },
  {
    value: 22,
    label: "Brdovec",
    surtax: 10
  },
  {
    value: 23,
    label: "Brela",
    surtax: 5
  },
  {
    value: 24,
    label: "Brestovac",
    surtax: 5
  },
  {
    value: 25,
    label: "Breznica",
    surtax: 10
  },
  {
    value: 279,
    label: "Breznički Hum",
    surtax: 3
  },
  {
    value: 26,
    label: "Brinje",
    surtax: 10
  },
  {
    value: 27,
    label: "Brodski Stupnik",
    surtax: 10
  },
  {
    value: 28,
    label: "Buje",
    surtax: 6
  },
  {
    value: 29,
    label: "Bukovlje",
    surtax: 10
  },
  {
    value: 317,
    label: "Buzet",
    surtax: 6
  },
  {
    value: 37,
    label: "Čabar",
    surtax: 5
  },
  {
    value: 38,
    label: "Čaglin",
    surtax: 5
  },
  {
    value: 39,
    label: "Čakovec",
    surtax: 0
  },
  {
    value: 40,
    label: "Čazma",
    surtax: 5
  },
  {
    value: 41,
    label: "Čeminac",
    surtax: 10
  },
  {
    value: 295,
    label: "Čepin",
    surtax: 10
  },
  {
    value: 30,
    label: "Cerna",
    surtax: 5
  },
  {
    value: 31,
    label: "Cernik",
    surtax: 10
  },
  {
    value: 32,
    label: "Cerovlje",
    surtax: 2
  },
  {
    value: 33,
    label: "Cestica",
    surtax: 10
  },
  {
    value: 34,
    label: "Cista Provo",
    surtax: 3
  },
  {
    value: 282,
    label: "Civljane",
    surtax: 5
  },
  {
    value: 36,
    label: "Crikvenica",
    surtax: 10
  },
  {
    value: 42,
    label: "Darda",
    surtax: 5
  },
  {
    value: 304,
    label: "Daruvar",
    surtax: 10
  },
  {
    value: 43,
    label: "Davor",
    surtax: 10
  },
  {
    value: 44,
    label: "Delnice",
    surtax: 5
  },
  {
    value: 45,
    label: "Dežanovac",
    surtax: 5
  },
  {
    value: 46,
    label: "Dicmo",
    surtax: 8
  },
  {
    value: 318,
    label: "Donja Stubica",
    surtax: 10
  },
  {
    value: 47,
    label: "Donja Voća",
    surtax: 10
  },
  {
    value: 48,
    label: "Donji Andrijevci",
    surtax: 8
  },
  {
    value: 310,
    label: "Donji Kukuruzari",
    surtax: 6
  },
  {
    value: 49,
    label: "Donji Lapac",
    surtax: 5
  },
  {
    value: 50,
    label: "Donji Martijanec",
    surtax: 5
  },
  {
    value: 51,
    label: "Donji Miholjac",
    surtax: 5
  },
  {
    value: 52,
    label: "Dragalić",
    surtax: 10
  },
  {
    value: 53,
    label: "Draž",
    surtax: 2
  },
  {
    value: 54,
    label: "Drenovci",
    surtax: 5
  },
  {
    value: 55,
    label: "Drniš",
    surtax: 5
  },
  {
    value: 284,
    label: "Dubrava",
    surtax: 6
  },
  {
    value: 57,
    label: "Dubravica",
    surtax: 10
  },
  {
    value: 311,
    label: "Dubrovačko primorje",
    surtax: 10
  },
  {
    value: 58,
    label: "Dubrovnik",
    surtax: 10
  },
  {
    value: 59,
    label: "Duga Resa",
    surtax: 10
  },
  {
    value: 61,
    label: "Dugo Selo",
    surtax: 9
  },
  {
    value: 60,
    label: "Dugopolje",
    surtax: 0
  },
  {
    value: 62,
    label: "Dvor",
    surtax: 5
  },
  {
    value: 63,
    label: "Đakovo",
    surtax: 10
  },
  {
    value: 64,
    label: "Đurđenovac",
    surtax: 10
  },
  {
    value: 312,
    label: "Đurmanec",
    surtax: 0
  },
  {
    value: 65,
    label: "Erdut",
    surtax: 5
  },
  {
    value: 335,
    label: "Ernestovo",
    surtax: 10
  },
  {
    value: 66,
    label: "Ervenik",
    surtax: 3
  },
  {
    value: 67,
    label: "Farkaševac",
    surtax: 3
  },
  {
    value: 68,
    label: "Fažana",
    surtax: 3
  },
  {
    value: 325,
    label: "Ferićanci",
    surtax: 10
  },
  {
    value: 69,
    label: "Fužine",
    surtax: 5
  },
  {
    value: 72,
    label: "Garčin",
    surtax: 10
  },
  {
    value: 70,
    label: "Garešnica",
    surtax: 10
  },
  {
    value: 73,
    label: "Gornji Bogićevci",
    surtax: 5
  },
  {
    value: 286,
    label: "Gornji Kneginec",
    surtax: 10
  },
  {
    value: 293,
    label: "Gospić",
    surtax: 10
  },
  {
    value: 71,
    label: "Gračac",
    surtax: 7
  },
  {
    value: 75,
    label: "Gračišće",
    surtax: 5
  },
  {
    value: 74,
    label: "Gradec",
    surtax: 5
  },
  {
    value: 76,
    label: "Grubišno polje",
    surtax: 5
  },
  {
    value: 334,
    label: "Gunja",
    surtax: 5
  },
  {
    value: 287,
    label: "Hrašćina",
    surtax: 5
  },
  {
    value: 77,
    label: "Hrvace",
    surtax: 10
  },
  {
    value: 326,
    label: "Hrvatska Dubica",
    surtax: 3
  },
  {
    value: 78,
    label: "Hrvatska Kostajnica",
    surtax: 6
  },
  {
    value: 80,
    label: "Ilok",
    surtax: 0
  },
  {
    value: 81,
    label: "Imotski",
    surtax: 6
  },
  {
    value: 82,
    label: "Ivanec",
    surtax: 10
  },
  {
    value: 83,
    label: "Ivanić Grad",
    surtax: 6
  },
  {
    value: 84,
    label: "Ivankovo",
    surtax: 10
  },
  {
    value: 85,
    label: "Jagodnjak",
    surtax: 3
  },
  {
    value: 86,
    label: "Jakovlje",
    surtax: 5
  },
  {
    value: 87,
    label: "Jakšić",
    surtax: 5
  },
  {
    value: 88,
    label: "Jastrebarsko",
    surtax: 9
  },
  {
    value: 89,
    label: "Jelsa",
    surtax: 10
  },
  {
    value: 283,
    label: "Kamanje",
    surtax: 10
  },
  {
    value: 91,
    label: "Kanfanar",
    surtax: 3
  },
  {
    value: 92,
    label: "Kapela",
    surtax: 8
  },
  {
    value: 93,
    label: "Kaptol",
    surtax: 10
  },
  {
    value: 94,
    label: "Karlovac",
    surtax: 9
  },
  {
    value: 95,
    label: "Karojba",
    surtax: 5
  },
  {
    value: 277,
    label: "Kaštel - Labinci",
    surtax: 5
  },
  {
    value: 96,
    label: "Kaštela",
    surtax: 12
  },
  {
    value: 288,
    label: "Kaštelir-Labinci-Castelliere-S.Domenica ",
    surtax: 5
  },
  {
    value: 98,
    label: "Kijevo",
    surtax: 5
  },
  {
    value: 99,
    label: "Kistanje",
    surtax: 3
  },
  {
    value: 100,
    label: "Klanjec",
    surtax: 12
  },
  {
    value: 101,
    label: "Klenovnik",
    surtax: 7
  },
  {
    value: 102,
    label: "Klinča Sela",
    surtax: 10
  },
  {
    value: 313,
    label: "Klis",
    surtax: 10
  },
  {
    value: 103,
    label: "Kloštar Ivanić",
    surtax: 2
  },
  {
    value: 308,
    label: "Kloštar Podravski",
    surtax: 5
  },
  {
    value: 104,
    label: "Kneževi Vinogradi",
    surtax: 4
  },
  {
    value: 105,
    label: "Knin",
    surtax: 10
  },
  {
    value: 319,
    label: "Komiža",
    surtax: 5
  },
  {
    value: 106,
    label: "Konavle",
    surtax: 10
  },
  {
    value: 107,
    label: "Končanica",
    surtax: 5
  },
  {
    value: 108,
    label: "Konjščina",
    surtax: 10
  },
  {
    value: 109,
    label: "Korčula",
    surtax: 6
  },
  {
    value: 110,
    label: "Kostajnica",
    surtax: 6
  },
  {
    value: 111,
    label: "Kraljevica",
    surtax: 5
  },
  {
    value: 112,
    label: "Krašić",
    surtax: 6
  },
  {
    value: 113,
    label: "Kravarsko",
    surtax: 5
  },
  {
    value: 114,
    label: "Križ",
    surtax: 2
  },
  {
    value: 115,
    label: "Križevci",
    surtax: 10
  },
  {
    value: 116,
    label: "Krnjak",
    surtax: 8
  },
  {
    value: 327,
    label: "Kula Norinska",
    surtax: 10
  },
  {
    value: 117,
    label: "Kutina",
    surtax: 12
  },
  {
    value: 341,
    label: "Kutjevo",
    surtax: 10
  },
  {
    value: 118,
    label: "Labin",
    surtax: 6
  },
  {
    value: 119,
    label: "Lanišće",
    surtax: 5
  },
  {
    value: 306,
    label: "Lasinja",
    surtax: 10
  },
  {
    value: 120,
    label: "Lastovo",
    surtax: 10
  },
  {
    value: 121,
    label: "Lepoglava",
    surtax: 8
  },
  {
    value: 337,
    label: "Lipik",
    surtax: 10
  },
  {
    value: 122,
    label: "Lipovljani",
    surtax: 6
  },
  {
    value: 328,
    label: "Lišane Ostrovičke",
    surtax: 6
  },
  {
    value: 123,
    label: "Ližnjan",
    surtax: 5
  },
  {
    value: 289,
    label: "Ljubešćica",
    surtax: 10
  },
  {
    value: 124,
    label: "Lokvičići",
    surtax: 7
  },
  {
    value: 125,
    label: "Lovas",
    surtax: 5
  },
  {
    value: 126,
    label: "Lovinac",
    surtax: 8
  },
  {
    value: 128,
    label: "Ludbreg",
    surtax: 12
  },
  {
    value: 129,
    label: "Luka",
    surtax: 5
  },
  {
    value: 298,
    label: "Lukač",
    surtax: 8
  },
  {
    value: 130,
    label: "Lumbarda",
    surtax: 5
  },
  {
    value: 131,
    label: "Lupoglav",
    surtax: 1
  },
  {
    value: 132,
    label: "Magadenovac",
    surtax: 2
  },
  {
    value: 329,
    label: "Majur",
    surtax: 5
  },
  {
    value: 133,
    label: "Makarska",
    surtax: 10
  },
  {
    value: 134,
    label: "Mali Bukovac",
    surtax: 10
  },
  {
    value: 135,
    label: "Marčana",
    surtax: 5
  },
  {
    value: 136,
    label: "Marija Gorica",
    surtax: 10
  },
  {
    value: 137,
    label: "Marijanci",
    surtax: 5
  },
  {
    value: 138,
    label: "Markušica",
    surtax: 5
  },
  {
    value: 297,
    label: "Maruševec",
    surtax: 5
  },
  {
    value: 339,
    label: "Matulji",
    surtax: 10
  },
  {
    value: 139,
    label: "Medulin",
    surtax: 5
  },
  {
    value: 140,
    label: "Metković",
    surtax: 8
  },
  {
    value: 342,
    label: "Mihovljan",
    surtax: 8
  },
  {
    value: 141,
    label: "Milna",
    surtax: 3
  },
  {
    value: 142,
    label: "Mljet",
    surtax: 10
  },
  {
    value: 143,
    label: "Motovun",
    surtax: 0
  },
  {
    value: 144,
    label: "Mrkopalj",
    surtax: 7
  },
  {
    value: 145,
    label: "Muć",
    surtax: 7
  },
  {
    value: 146,
    label: "Murter",
    surtax: 8
  },
  {
    value: 147,
    label: "Našice",
    surtax: 8
  },
  {
    value: 148,
    label: "Negoslavci",
    surtax: 5
  },
  {
    value: 149,
    label: "Nova Gradiška",
    surtax: 12
  },
  {
    value: 150,
    label: "Nova Kapela",
    surtax: 10
  },
  {
    value: 151,
    label: "Novi Marof",
    surtax: 10
  },
  {
    value: 152,
    label: "Novi Vinodolski",
    surtax: 7
  },
  {
    value: 153,
    label: "Novska",
    surtax: 8
  },
  {
    value: 154,
    label: "Nuštar",
    surtax: 6
  },
  {
    value: 320,
    label: "Ogulin",
    surtax: 5
  },
  {
    value: 314,
    label: "Okučani",
    surtax: 10
  },
  {
    value: 155,
    label: "Omiš",
    surtax: 8
  },
  {
    value: 156,
    label: "Opatija",
    surtax: 0
  },
  {
    value: 159,
    label: "Općina Gračac",
    surtax: 7
  },
  {
    value: 158,
    label: "Općina Gracin",
    surtax: 10
  },
  {
    value: 157,
    label: "Općina Špišić Bukovica",
    surtax: 9
  },
  {
    value: 278,
    label: "Opuzen",
    surtax: 10
  },
  {
    value: 161,
    label: "Orle",
    surtax: 5
  },
  {
    value: 162,
    label: "Osijek",
    surtax: 13
  },
  {
    value: 163,
    label: "Otočac",
    surtax: 7
  },
  {
    value: 165,
    label: "Otok",
    surtax: 5
  },
  {
    value: 166,
    label: "Ozalj",
    surtax: 10
  },
  {
    value: 307,
    label: "Pakrac",
    surtax: 7
  },
  {
    value: 167,
    label: "Pazin",
    surtax: 9
  },
  {
    value: 305,
    label: "Perušić",
    surtax: 2
  },
  {
    value: 168,
    label: "Petlovac",
    surtax: 5
  },
  {
    value: 292,
    label: "Petrijanec",
    surtax: 5
  },
  {
    value: 169,
    label: "Petrijevci",
    surtax: 5
  },
  {
    value: 170,
    label: "Petrinja",
    surtax: 10
  },
  {
    value: 171,
    label: "Pićan",
    surtax: 0
  },
  {
    value: 172,
    label: "Pirovac",
    surtax: 6
  },
  {
    value: 173,
    label: "Pisarovina",
    surtax: 6
  },
  {
    value: 174,
    label: "Pleternica",
    surtax: 0
  },
  {
    value: 175,
    label: "Plitvička jezera",
    surtax: 8
  },
  {
    value: 324,
    label: "Ploče",
    surtax: 10
  },
  {
    value: 176,
    label: "Podbablje",
    surtax: 6
  },
  {
    value: 177,
    label: "Podcrkavlje",
    surtax: 5
  },
  {
    value: 178,
    label: "Podgora",
    surtax: 10
  },
  {
    value: 330,
    label: "Podgorač",
    surtax: 5
  },
  {
    value: 179,
    label: "Podstrana",
    surtax: 10
  },
  {
    value: 180,
    label: "Pokupsko",
    surtax: 5
  },
  {
    value: 331,
    label: "Polača",
    surtax: 10
  },
  {
    value: 181,
    label: "Popovac",
    surtax: 3
  },
  {
    value: 182,
    label: "Popovača",
    surtax: 6
  },
  {
    value: 183,
    label: "Požega",
    surtax: 7
  },
  {
    value: 184,
    label: "Pregrada",
    surtax: 10
  },
  {
    value: 185,
    label: "Preseka",
    surtax: 5
  },
  {
    value: 186,
    label: "Primošten",
    surtax: 10
  },
  {
    value: 187,
    label: "Proložac",
    surtax: 5
  },
  {
    value: 188,
    label: "Promina",
    surtax: 5
  },
  {
    value: 189,
    label: "Pučišća",
    surtax: 5
  },
  {
    value: 190,
    label: "Pula",
    surtax: 12
  },
  {
    value: 191,
    label: "Pušća",
    surtax: 10
  },
  {
    value: 343,
    label: "Rab",
    surtax: 0
  },
  {
    value: 340,
    label: "Radoboj",
    surtax: 8
  },
  {
    value: 192,
    label: "Rakovec",
    surtax: 3
  },
  {
    value: 193,
    label: "Rakovica",
    surtax: 8
  },
  {
    value: 194,
    label: "Raša",
    surtax: 6
  },
  {
    value: 195,
    label: "Ravna Gora",
    surtax: 7.5
  },
  {
    value: 196,
    label: "Rešetari",
    surtax: 10
  },
  {
    value: 197,
    label: "Ribnik",
    surtax: 5
  },
  {
    value: 285,
    label: "Rijeka",
    surtax: 13
  },
  {
    value: 199,
    label: "Rovinj",
    surtax: 6
  },
  {
    value: 200,
    label: "Rugvica",
    surtax: 0
  },
  {
    value: 201,
    label: "Runovići",
    surtax: 6
  },
  {
    value: 202,
    label: "Ružić",
    surtax: 5
  },
  {
    value: 321,
    label: "Senj",
    surtax: 10
  },
  {
    value: 222,
    label: "Šibenik",
    surtax: 10
  },
  {
    value: 203,
    label: "Sibinj",
    surtax: 10
  },
  {
    value: 204,
    label: "Sinj",
    surtax: 0
  },
  {
    value: 205,
    label: "Sisak",
    surtax: 10
  },
  {
    value: 301,
    label: "Škabrnja",
    surtax: 10
  },
  {
    value: 206,
    label: "Skradin",
    surtax: 5
  },
  {
    value: 281,
    label: "Slatina",
    surtax: 6
  },
  {
    value: 207,
    label: "Slavonski Brod",
    surtax: 6
  },
  {
    value: 208,
    label: "Slunj",
    surtax: 5
  },
  {
    value: 209,
    label: "Solin",
    surtax: 10
  },
  {
    value: 223,
    label: "Špišić Bukovica",
    surtax: 9
  },
  {
    value: 210,
    label: "Split",
    surtax: 15
  },
  {
    value: 211,
    label: "Sračinec",
    surtax: 5
  },
  {
    value: 212,
    label: "Stara Gradiška",
    surtax: 5
  },
  {
    value: 323,
    label: "Stari Grad",
    surtax: 10
  },
  {
    value: 213,
    label: "Stari Mikanovci",
    surtax: 10
  },
  {
    value: 214,
    label: "Staro Petrovo Selo",
    surtax: 10
  },
  {
    value: 332,
    label: "Štefanje",
    surtax: 0
  },
  {
    value: 224,
    label: "Štitar",
    surtax: 5
  },
  {
    value: 215,
    label: "Stupnik",
    surtax: 6
  },
  {
    value: 338,
    label: "Supetar",
    surtax: 10
  },
  {
    value: 216,
    label: "Sutivan",
    surtax: 10
  },
  {
    value: 299,
    label: "Sveta Nedelja (Labin)",
    surtax: 6
  },
  {
    value: 290,
    label: "Sveta Nedjelja (Samoborska)",
    surtax: 0
  },
  {
    value: 217,
    label: "Sveti Đurđ",
    surtax: 5
  },
  {
    value: 315,
    label: "Sveti Filip i Jakov",
    surtax: 10
  },
  {
    value: 300,
    label: "Sveti Ilija",
    surtax: 10
  },
  {
    value: 219,
    label: "Sveti Ivan Zelina",
    surtax: 12
  },
  {
    value: 302,
    label: "Sveti Lovreč",
    surtax: 5
  },
  {
    value: 220,
    label: "Sveti Petar u šumi",
    surtax: 7
  },
  {
    value: 221,
    label: "Svetvinčenat",
    surtax: 5
  },
  {
    value: 225,
    label: "Tinjan",
    surtax: 5
  },
  {
    value: 226,
    label: "Tisno",
    surtax: 9
  },
  {
    value: 227,
    label: "Tordinci",
    surtax: 5
  },
  {
    value: 228,
    label: "Tribunj",
    surtax: 6
  },
  {
    value: 229,
    label: "Trnovec Bartolovečki",
    surtax: 7
  },
  {
    value: 230,
    label: "Trogir",
    surtax: 8
  },
  {
    value: 231,
    label: "Trpanj",
    surtax: 10
  },
  {
    value: 232,
    label: "Tučepi",
    surtax: 10
  },
  {
    value: 233,
    label: "Udbina",
    surtax: 5
  },
  {
    value: 234,
    label: "Umag",
    surtax: 6
  },
  {
    value: 235,
    label: "Unešić",
    surtax: 5
  },
  {
    value: 236,
    label: "Valpovo",
    surtax: 0
  },
  {
    value: 237,
    label: "Varaždin",
    surtax: 7.5
  },
  {
    value: 238,
    label: "Varaždinske Toplice",
    surtax: 10
  },
  {
    value: 239,
    label: "Vela Luka",
    surtax: 9
  },
  {
    value: 240,
    label: "Velika Gorica",
    surtax: 12
  },
  {
    value: 241,
    label: "Velika Kopanica",
    surtax: 7
  },
  {
    value: 242,
    label: "Veliki Bukovec",
    surtax: 5
  },
  {
    value: 243,
    label: "Veliko Trgovišće",
    surtax: 7.5
  },
  {
    value: 244,
    label: "Vidovec",
    surtax: 7
  },
  {
    value: 246,
    label: "Vinica",
    surtax: 5
  },
  {
    value: 245,
    label: "Vinkovci",
    surtax: 10
  },
  {
    value: 247,
    label: "Virovitica",
    surtax: 10
  },
  {
    value: 248,
    label: "Vis",
    surtax: 3
  },
  {
    value: 250,
    label: "Višnjan",
    surtax: 5
  },
  {
    value: 249,
    label: "Visoko",
    surtax: 10
  },
  {
    value: 294,
    label: "Vižinada-Visinada",
    surtax: 3
  },
  {
    value: 296,
    label: "Vladislavci",
    surtax: 10
  },
  {
    value: 252,
    label: "Vodice",
    surtax: 6
  },
  {
    value: 333,
    label: "Vodnjan - Dignano",
    surtax: 7.5
  },
  {
    value: 336,
    label: "Vođinci",
    surtax: 10
  },
  {
    value: 254,
    label: "Vojnić",
    surtax: 7.5
  },
  {
    value: 255,
    label: "Vrbanja",
    surtax: 5
  },
  {
    value: 256,
    label: "Vrbje",
    surtax: 3
  },
  {
    value: 257,
    label: "Vrbovec",
    surtax: 12
  },
  {
    value: 258,
    label: "Vrbovsko",
    surtax: 10
  },
  {
    value: 259,
    label: "Vrgorac",
    surtax: 10
  },
  {
    value: 280,
    label: "Vrhovine",
    surtax: 5
  },
  {
    value: 261,
    label: "Vrlika",
    surtax: 7
  },
  {
    value: 291,
    label: "Zadar",
    surtax: 12
  },
  {
    value: 262,
    label: "Zadvarje",
    surtax: 0
  },
  {
    value: 263,
    label: "Zagreb",
    surtax: 18
  },
  {
    value: 264,
    label: "Zagvozd",
    surtax: 6
  },
  {
    value: 160,
    label: "Žakanje",
    surtax: 5
  },
  {
    value: 265,
    label: "Zaprešić",
    surtax: 12
  },
  {
    value: 266,
    label: "Zlatar",
    surtax: 10
  },
  {
    value: 267,
    label: "Zlatar Bistrica",
    surtax: 5
  },
  {
    value: 268,
    label: "Zmijavci",
    surtax: 8
  },
  {
    value: 270,
    label: "Žminj",
    surtax: 5
  },
  {
    value: 271,
    label: "Žumberak",
    surtax: 3
  },
  {
    value: 272,
    label: "Župa Dubrovačka",
    surtax: 10
  },
  {
    value: 273,
    label: "Županja",
    surtax: 9
  }
];
class ga {
  async getPlaces() {
    try {
      return Ra;
    } catch {
      return [];
    }
  }
  async getPlacesWithSurtax() {
    try {
      return ca;
    } catch {
      return [];
    }
  }
}
const ea = new ga();
var A = /* @__PURE__ */ ((i) => (i[i.none = 0] = "none", i[i.partial = 1] = "partial", i[i.full = 2] = "full", i))(A || {}), M = /* @__PURE__ */ ((i) => (i.NetToGross = "n2g", i.GrossToNet = "g2n", i))(M || {}), E = /* @__PURE__ */ ((i) => (i[i.regular = 0] = "regular", i[i.artist = 1] = "artist", i))(E || {});
class pa {
  async calculate(e) {
    return e.type === M.GrossToNet ? this.grossToNet(e) : this.netToGross(e);
  }
  async grossToNet(e) {
    return new Promise(async (r) => {
      const h = this.getContributionBaseReduction(
        e.amount
      ), s = e.amount < 285 ? 0 : (e.amount - h) * (15 / 100), p = e.amount * (5 / 100), m = s + p, _ = Math.min(
        this.getExemption(e),
        e.amount - m
      ), u = Math.max(
        0,
        e.amount - m - _
      ), P = Math.min(5e3, u) * e.place.lowRate, B = Math.max(0, u - 5e3) * e.place.highRate, j = P + B, V = e.amount * 16.5 / 100, x = e.amount + V, R = e.amount - m - j;
      r({
        net_amount: R,
        gross_1_amount: e.amount,
        pension_1_amount: s,
        pension_1_percent: 15,
        pension_2_amount: p,
        pension_2_percent: 5,
        gross_contribution_amount: m,
        gross_contribution_percent: 15 + 5,
        exemption_amount: _,
        taxable_amount: u,
        tax_lower: P,
        tax_higher: B,
        tax_amount: j,
        tax_and_surtax_amount: j,
        gross_2_amount: x,
        health_insurance_amount: V,
        health_insurance_percent: 16.5,
        salary_contribution_amount: V
      });
    });
  }
  async netToGross(e) {
    const a = e.amount, o = this.getExemption(e), b = e.place.lowRate, k = e.place.highRate, r = m(b), h = m(k), s = _(), p = u();
    function m(P) {
      return P / (1 - P) + 1;
    }
    function _() {
      return a <= o ? a : a > o && a <= 4200 * (1 / r) + o ? r * (a - o) + o : a > 4200 * (1 / r) + o ? 4200 + o + (a - (4200 - 4200 * b + o)) * h : 0;
    }
    function u() {
      return s <= 285 ? s / 0.95 : s > 285 && s <= 605 ? (s - 45) / 0.8 : s > 605 && s <= 1040 ? (s - 97.5) / 0.725 : s > 1040 ? s / 0.8 : 0;
    }
    return this.grossToNet({
      ...e,
      amount: p,
      type: M.GrossToNet
    });
  }
  getContributionBaseReduction(e) {
    return e < 1300 ? e < 700 ? 300 : (1300 - e) * 0.5 : 0;
  }
  getExemption(e) {
    const r = e.noBaseExemption ? 0 : 600;
    let h = r;
    if (e.children === 1 && (h += r * 0.5), e.children > 1) {
      h += r * 0.5;
      let s = 0.5;
      for (let p = 2; p <= e.children; p++)
        s += p / 10, h += r * Math.min(s, 4.9);
    }
    for (let s = 1; s <= e.dependents; s++)
      h += r * 0.5;
    return e.disability === A.partial && (h += r * 0.3), e.disability === A.full && (h += r * 1), h;
  }
}
const _a = new pa();
function ua(i) {
  return typeof i == "number" && isFinite(i);
}
function la(i) {
  return new Promise((e) => {
    const a = setTimeout(() => {
      e(a);
    }, i);
  });
}
function ta(i, e = 50) {
  var r, h;
  const o = (((h = (r = document.getElementsByTagName("header")) == null ? void 0 : r[0]) == null ? void 0 : h.offsetHeight) || 0) + e, k = i.getBoundingClientRect().top + window.scrollY - o;
  window.scrollTo({
    top: k,
    behavior: "smooth"
  });
}
const T = /* @__PURE__ */ N({
  __name: "ResultText",
  props: {
    value: {},
    isPercent: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = i, a = C(), o = O(
      () => ua(e.value) ? a.n(e.value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) : e.value
    ), b = O(() => ua(e.value) ? e.isPercent ? "%" : " €" : ""), k = O(() => `${o.value}${b.value}`.trim());
    return (r, h) => (y(), G(t(K), {
      "no-margin": "",
      semibold: ""
    }, {
      default: d(() => [
        S($(k.value), 1)
      ]),
      _: 1
    }));
  }
}), ma = { class: "result__row" }, wa = { class: "result__row__title" }, da = { class: "result__row__values" }, xa = {
  key: 1,
  class: "result__row__wrapper"
}, ka = { class: "result__row__title" }, ja = { class: "result__row__values" }, fa = /* @__PURE__ */ N({
  __name: "ResultRow",
  props: {
    name: { default: "" },
    description: { default: void 0 },
    percentage: { default: void 0 },
    value: { default: 0 },
    isOpen: { type: Boolean, default: !1 }
  },
  setup(i) {
    const a = D(i.isOpen);
    return (o, b) => (y(), L("li", ma, [
      o.description ? (y(), G(t(va), {
        key: 0,
        modelValue: a.value,
        "onUpdate:modelValue": b[0] || (b[0] = (k) => a.value = k),
        style: { width: "100%" },
        size: "sm"
      }, {
        header: d(() => [
          v("div", wa, [
            l(T, { value: o.name }, null, 8, ["value"]),
            o.percentage ? (y(), G(T, {
              key: 0,
              value: o.percentage,
              style: { marginLeft: "var(--mp-space-20)" },
              "is-percent": ""
            }, null, 8, ["value"])) : z("", !0)
          ]),
          v("div", da, [
            oa(o.$slots, "default", {}, () => [
              l(T, { value: o.value }, null, 8, ["value"])
            ], !0)
          ])
        ]),
        default: d(() => [
          v("div", null, [
            l(t(K), null, {
              default: d(() => [
                S($(o.description), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      }, 8, ["modelValue"])) : (y(), L("div", xa, [
        v("div", ka, [
          v("span", null, [
            l(T, { value: o.name }, null, 8, ["value"]),
            o.percentage ? (y(), G(T, {
              key: 0,
              value: o.percentage,
              style: { marginLeft: "var(--mp-space-20)" },
              "is-percent": ""
            }, null, 8, ["value"])) : z("", !0)
          ])
        ]),
        v("div", ja, [
          oa(o.$slots, "default", {}, () => [
            l(T, { value: o.value }, null, 8, ["value"])
          ], !0)
        ])
      ]))
    ]));
  }
});
const I = (i, e) => {
  const a = i.__vccOpts || i;
  for (const [o, b] of e)
    a[o] = b;
  return a;
}, g = /* @__PURE__ */ I(fa, [["__scopeId", "data-v-c0056f31"]]), Pa = { class: "result__title" }, ya = { class: "result__basic" }, Sa = { class: "result__highlight" }, $a = { class: "result__highlight" }, Ba = { class: "result__detailed" }, Va = { class: "result__detailed-table result__detailed-table--no-scroll" }, Ka = /* @__PURE__ */ N({
  __name: "SalaryCalculation",
  props: {
    result: {}
  },
  setup(i) {
    const { isMobile: e } = U();
    return (a, o) => a.result ? (y(), G(t(F), {
      key: 0,
      class: "result",
      p: t(e) ? "unset" : "lg",
      border: !t(e),
      shadow: !t(e)
    }, {
      default: d(() => [
        v("div", Pa, [
          l(t(K), { type: "h5" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_title")), 1)
            ]),
            _: 1
          }),
          l(t(K), { "no-margin": "" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_warning")), 1)
            ]),
            _: 1
          })
        ]),
        v("div", ya, [
          v("div", Sa, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_gross")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.gross_1_amount,
              as: "h4"
            }, null, 8, ["value"])
          ]),
          v("div", $a, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_net")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.net_amount,
              as: "h4"
            }, null, 8, ["value"])
          ])
        ]),
        v("div", Ba, [
          v("ul", Va, [
            l(g, {
              name: "(1) " + a.$t("mp_calculator_croatia.result.gross_amount"),
              value: a.result.gross_1_amount
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(2) " + a.$t("mp_calculator_croatia.result.pension_1"),
              description: a.$t("mp_calculator_croatia.result.pension_1_more"),
              percentage: a.result.pension_1_percent,
              value: a.result.pension_1_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(3) " + a.$t("mp_calculator_croatia.result.pension_2"),
              description: a.$t("mp_calculator_croatia.result.pension_2_more"),
              percentage: a.result.pension_2_percent,
              value: a.result.pension_2_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(4) " + a.$t("mp_calculator_croatia.result.pension_contribution") + " (2+3)",
              percentage: a.result.gross_contribution_percent,
              value: a.result.gross_contribution_amount
            }, null, 8, ["name", "percentage", "value"]),
            l(g, {
              name: "(5) " + a.$t("mp_calculator_croatia.result.exemption"),
              description: a.$t("mp_calculator_croatia.result.exemption_more"),
              value: a.result.exemption_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(6) " + a.$t("mp_calculator_croatia.result.tax_base") + " (1-4-5)",
              description: a.$t("mp_calculator_croatia.result.taxable_amount_more"),
              value: a.result.taxable_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(7) " + a.$t("mp_calculator_croatia.result.tax"),
              description: a.$t("mp_calculator_croatia.result.tax_more"),
              value: a.result.tax_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(10) " + a.$t("mp_calculator_croatia.result.health_insurance"),
              percentage: a.result.health_insurance_percent,
              value: a.result.health_insurance_amount
            }, null, 8, ["name", "percentage", "value"]),
            l(g, {
              name: "(11) " + a.$t("mp_calculator_croatia.result.gross_2") + " (1+10)",
              description: a.$t("mp_calculator_croatia.result.gross_2_more"),
              value: a.result.gross_2_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(12) " + a.$t("mp_calculator_croatia.result.amount_net"),
              value: a.result.net_amount
            }, null, 8, ["name", "value"])
          ])
        ]),
        z("", !0)
      ]),
      _: 1
    }, 8, ["p", "border", "shadow"])) : z("", !0);
  }
});
const Ma = /* @__PURE__ */ I(Ka, [["__scopeId", "data-v-5f0c3a5e"]]), Ta = { class: "calc" }, za = { class: "calc__form form" }, Ga = { class: "form__fieldset form__disability" }, Na = { class: "form__fieldset form__controls" }, Da = /* @__PURE__ */ N({
  __name: "Salary",
  props: {
    input: {}
  },
  emits: ["change"],
  async setup(i, { emit: e }) {
    var V, x, R, c;
    let a, o;
    const b = i, k = e, r = C();
    r.mergeLocaleMessage("hr", aa), r.mergeLocaleMessage("en", q);
    const { isMobile: h } = U(), s = D(null), p = ([a, o] = H(() => ea.getPlaces()), a = await a, o(), a), m = [
      {
        value: A.none,
        label: r.t("mp_calculator_croatia.form.disability_none")
      },
      {
        value: A.partial,
        label: r.t("mp_calculator_croatia.form.disability_partial")
      },
      {
        value: A.full,
        label: r.t("mp_calculator_croatia.form.disability_full")
      }
    ], _ = D(), u = W({
      amount: ((V = b.input) == null ? void 0 : V.amount) ?? 1e3,
      place: p.find((n) => {
        var w, f;
        return n.value === ((f = (w = b.input) == null ? void 0 : w.place) == null ? void 0 : f.value);
      }) ?? p.find((n) => n.label === "Zagreb") ?? p[0],
      children: ((x = b.input) == null ? void 0 : x.children) ?? 0,
      dependents: ((R = b.input) == null ? void 0 : R.dependents) ?? 0,
      disability: m.find((n) => {
        var w;
        return n.value === ((w = b.input) == null ? void 0 : w.disability);
      }) ?? m[0],
      type: (c = b.input) == null ? void 0 : c.type
    }), P = O(() => ({
      amount: +u.amount,
      place: u.place,
      children: +u.children,
      dependents: +u.dependents,
      disability: u.disability.value,
      type: u.type ?? M.NetToGross
    }));
    function B(n) {
      return (n * 100).toFixed(2);
    }
    async function j(n) {
      n && (u.type = n), k("change", P.value), _.value = await _a.calculate(P.value), s.value && (await la(100), ta(s.value));
    }
    return Y(() => {
      u.type && j();
    }), (n, w) => (y(), L("section", Ta, [
      l(t(F), {
        class: "calc__card",
        p: t(h) ? "unset" : "lg",
        border: !t(h),
        shadow: !t(h)
      }, {
        default: d(() => [
          v("form", za, [
            l(t(J), {
              modelValue: u.amount,
              "onUpdate:modelValue": w[0] || (w[0] = (f) => u.amount = f),
              class: "form__input",
              label: n.$t("mp_calculator_croatia.form.amount"),
              min: "0"
            }, null, 8, ["modelValue", "label"]),
            l(t(Q), {
              modelValue: u.place,
              "onUpdate:modelValue": w[1] || (w[1] = (f) => u.place = f),
              unselectable: !1,
              class: "form__input",
              options: t(p),
              searchable: "",
              "get-label": (f) => `${f.label} (${B(f.lowRate)}% / ${B(f.highRate)}%)`,
              label: n.$t("mp_calculator_croatia.form.place"),
              "max-menu-height": 200
            }, null, 8, ["modelValue", "options", "get-label", "label"]),
            l(t(J), {
              modelValue: u.children,
              "onUpdate:modelValue": w[2] || (w[2] = (f) => u.children = f),
              class: "form__input",
              label: n.$t("mp_calculator_croatia.form.children"),
              min: "0"
            }, null, 8, ["modelValue", "label"]),
            l(t(J), {
              modelValue: u.dependents,
              "onUpdate:modelValue": w[3] || (w[3] = (f) => u.dependents = f),
              class: "form__input",
              label: n.$t("mp_calculator_croatia.form.dependents"),
              min: "0"
            }, null, 8, ["modelValue", "label"]),
            v("fieldset", Ga, [
              (y(), L(ia, null, ra(m, (f) => l(t(na), {
                key: f.value,
                modelValue: u.disability,
                "onUpdate:modelValue": w[4] || (w[4] = (sa) => u.disability = sa),
                label: f.label,
                value: f
              }, null, 8, ["modelValue", "label", "value"])), 64))
            ]),
            v("fieldset", Na, [
              l(t(Z), {
                text: n.$t("mp_calculator_croatia.form.net_to_gross"),
                onClick: w[5] || (w[5] = (f) => j(t(M).NetToGross))
              }, null, 8, ["text"]),
              l(t(Z), {
                text: n.$t("mp_calculator_croatia.form.gross_to_net"),
                onClick: w[6] || (w[6] = (f) => j(t(M).GrossToNet))
              }, null, 8, ["text"])
            ])
          ]),
          l(t(K), {
            as: "p",
            type: "body2",
            class: "calc__info",
            style: { "margin-bottom": "0" }
          }, {
            default: d(() => [
              l(t(K), {
                bold: "",
                type: "body2"
              }, {
                default: d(() => [
                  S($(n.$t("mp_calculator_croatia.form.gross")), 1)
                ]),
                _: 1
              }),
              S(" " + $(n.$t("mp_calculator_croatia.form.gross_is_calculation_amount")) + ". ", 1),
              w[7] || (w[7] = v("br", null, null, -1)),
              l(t(K), {
                bold: "",
                type: "body2"
              }, {
                default: d(() => [
                  S($(n.$t("mp_calculator_croatia.form.net")), 1)
                ]),
                _: 1
              }),
              S(" " + $(n.$t("mp_calculator_croatia.form.net_is_final_amount")) + ". ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["p", "border", "shadow"]),
      t(h) ? (y(), G(t(X), {
        key: 0,
        margin: "none"
      })) : z("", !0),
      v("div", {
        ref_key: "calculationRef",
        ref: s
      }, [
        l(Ma, { result: _.value }, null, 8, ["result"])
      ], 512)
    ]));
  }
});
const pe = /* @__PURE__ */ I(Da, [["__scopeId", "data-v-5ceb1427"]]);
class La {
  async calculate(e) {
    return e.type === M.GrossToNet ? this.grossToNet(e) : this.netToGross(e);
  }
  async grossToNet(e) {
    const h = e.place.lowRate * 100, s = 7.5;
    return new Promise(async (p) => {
      const m = Math.max(0, e.amount) * 0.3, _ = e.author_type === 1 ? Math.max(0, e.amount) * (25 / 100) : 0, u = e.amount - (m + _), P = Math.min(u, 57222) * (7.5 / 100), B = Math.min(u, 57222) * (2.5 / 100), j = P + B, V = Math.max(
        0,
        e.amount - m - _ - j
      ), x = V * (h / 100), R = x, c = u * (s / 100), n = e.amount + c, w = e.amount - j - R;
      p({
        author_type: e.author_type,
        net_amount: w,
        gross_1_amount: e.amount,
        expense: m,
        expense_percent: 30,
        expense_author: _,
        expense_author_percent: 25,
        contribution_base: u,
        pension_1_amount: P,
        pension_1_percent: 7.5,
        pension_2_amount: B,
        pension_2_percent: 2.5,
        gross_contribution_amount: j,
        taxable_amount: V,
        tax_amount: x,
        tax_percent: h,
        health_insurance_amount: c,
        health_insurance_percent: s,
        gross_2_amount: n
      });
    });
  }
  async netToGross(e) {
    const a = e.amount, o = e.place.lowRate * 100, b = r(), k = a * b;
    function r() {
      return e.author_type === 0 ? (7 + 0.63 * o) / (93 - 0.63 * o) + 1 : (4.5 + 0.405 * o) / (95.5 - 0.405 * o) + 1;
    }
    return this.grossToNet({
      ...e,
      amount: k,
      type: M.GrossToNet
    });
  }
}
const Ia = new La(), Oa = { class: "result__title" }, Aa = { class: "result__basic" }, Za = { class: "result__highlight" }, Ua = { class: "result__highlight" }, Fa = { class: "result__detailed" }, Ja = { class: "result__detailed-table result__detailed-table--no-scroll" }, Ca = /* @__PURE__ */ N({
  __name: "AuthorCalculation",
  props: {
    result: {}
  },
  setup(i) {
    const { isMobile: e } = U();
    return (a, o) => a.result ? (y(), G(t(F), {
      key: 0,
      class: "result",
      p: t(e) ? "unset" : "lg",
      border: !t(e),
      shadow: !t(e)
    }, {
      default: d(() => [
        v("div", Oa, [
          l(t(K), { type: "h5" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_title")), 1)
            ]),
            _: 1
          }),
          l(t(K), { "no-margin": "" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_warning")), 1)
            ]),
            _: 1
          })
        ]),
        v("div", Aa, [
          v("div", Za, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_gross")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.gross_1_amount,
              as: "h4"
            }, null, 8, ["value"])
          ]),
          v("div", Ua, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_net")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.net_amount,
              as: "h4"
            }, null, 8, ["value"])
          ])
        ]),
        v("div", Fa, [
          v("ul", Ja, [
            l(g, {
              name: "(1) " + a.$t("mp_calculator_croatia.result.gross_amount"),
              value: a.result.gross_1_amount
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(2) " + a.$t("mp_calculator_croatia.result.expense"),
              description: a.$t("mp_calculator_croatia.result.expense_more"),
              percentage: a.result.expense_percent,
              value: a.result.expense
            }, null, 8, ["name", "description", "percentage", "value"]),
            a.result.author_type === 1 ? (y(), G(g, {
              key: 0,
              name: "(2*) " + a.$t("mp_calculator_croatia.result.expense"),
              percentage: a.result.expense_author_percent,
              value: a.result.expense_author
            }, null, 8, ["name", "percentage", "value"])) : z("", !0),
            l(g, {
              name: "(3) " + a.$t("mp_calculator_croatia.result.contribution_base"),
              value: a.result.contribution_base
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(4) " + a.$t("mp_calculator_croatia.result.pension_1"),
              description: a.$t("mp_calculator_croatia.result.pension_1_more"),
              percentage: a.result.pension_1_percent,
              value: a.result.pension_1_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(5) " + a.$t("mp_calculator_croatia.result.pension_2"),
              description: a.$t("mp_calculator_croatia.result.pension_2_more"),
              percentage: a.result.pension_2_percent,
              value: a.result.pension_2_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(6) " + a.$t("mp_calculator_croatia.result.gross_contribution"),
              value: a.result.gross_contribution_amount
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(7) " + a.$t("mp_calculator_croatia.result.tax_base"),
              description: a.$t("mp_calculator_croatia.result.taxable_amount_more"),
              value: a.result.taxable_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(8) " + a.$t("mp_calculator_croatia.result.tax"),
              description: a.$t("mp_calculator_croatia.result.tax_more"),
              percentage: a.result.tax_percent,
              value: a.result.tax_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(11) " + a.$t("mp_calculator_croatia.result.health_insurance"),
              percentage: a.result.health_insurance_percent,
              value: a.result.health_insurance_amount
            }, null, 8, ["name", "percentage", "value"]),
            l(g, {
              name: "(12) " + a.$t("mp_calculator_croatia.result.total_expense") + " (1+11)",
              description: a.$t("mp_calculator_croatia.result.total_expense_more"),
              value: a.result.gross_2_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(13) " + a.$t("mp_calculator_croatia.result.amount_net"),
              value: a.result.net_amount
            }, null, 8, ["name", "value"])
          ])
        ]),
        z("", !0)
      ]),
      _: 1
    }, 8, ["p", "border", "shadow"])) : z("", !0);
  }
});
const Ea = /* @__PURE__ */ I(Ca, [["__scopeId", "data-v-8ddab239"]]), Ha = { class: "calc" }, Wa = { class: "calc__form form" }, Ya = { class: "form__fieldset form__author-type" }, Qa = { class: "form__fieldset form__controls" }, Xa = /* @__PURE__ */ N({
  __name: "Author",
  props: {
    input: {}
  },
  emits: ["change"],
  async setup(i, { emit: e }) {
    var V, x;
    let a, o;
    const b = i, k = e, r = C();
    r.mergeLocaleMessage("hr", aa), r.mergeLocaleMessage("en", q);
    const { isMobile: h } = U(), s = D(null), p = ([a, o] = H(() => ea.getPlaces()), a = await a, o(), a), m = [
      {
        value: E.regular,
        label: r.t("mp_calculator_croatia.form.author_regular")
      },
      { value: E.artist, label: r.t("mp_calculator_croatia.form.author_artist") }
    ], _ = D(), u = W({
      amount: ((V = b.input) == null ? void 0 : V.amount) ?? 5e3,
      place: p.find((R) => {
        var c, n;
        return R.value === ((n = (c = b.input) == null ? void 0 : c.place) == null ? void 0 : n.value);
      }) ?? p.find((R) => R.label === "Zagreb") ?? p[0],
      author_type: m.find((R) => {
        var c;
        return R.value === ((c = b.input) == null ? void 0 : c.author_type);
      }) ?? m[0],
      type: (x = b.input) == null ? void 0 : x.type
    }), P = O(() => ({
      amount: +u.amount,
      place: u.place,
      author_type: u.author_type.value,
      type: u.type ?? M.NetToGross
    }));
    function B(R) {
      return (R * 100).toFixed(2);
    }
    async function j(R) {
      R && (u.type = R), k("change", P.value), _.value = await Ia.calculate(P.value), s.value && (await la(100), ta(s.value));
    }
    return Y(() => {
      u.type && j();
    }), (R, c) => (y(), L("section", Ha, [
      l(t(F), {
        class: "calc__card",
        p: t(h) ? "unset" : "lg",
        border: !t(h),
        shadow: !t(h)
      }, {
        default: d(() => [
          v("form", Wa, [
            l(t(J), {
              modelValue: u.amount,
              "onUpdate:modelValue": c[0] || (c[0] = (n) => u.amount = n),
              label: R.$t("mp_calculator_croatia.form.amount"),
              min: "0"
            }, null, 8, ["modelValue", "label"]),
            l(t(Q), {
              modelValue: u.place,
              "onUpdate:modelValue": c[1] || (c[1] = (n) => u.place = n),
              unselectable: !1,
              options: t(p),
              "get-label": (n) => `${n.label} (${B(n.lowRate)}%)`,
              label: R.$t("mp_calculator_croatia.form.place"),
              "max-menu-height": 200
            }, null, 8, ["modelValue", "options", "get-label", "label"]),
            v("fieldset", Ya, [
              (y(), L(ia, null, ra(m, (n) => l(t(na), {
                key: n.value,
                modelValue: u.author_type,
                "onUpdate:modelValue": c[2] || (c[2] = (w) => u.author_type = w),
                label: n.label,
                value: n
              }, null, 8, ["modelValue", "label", "value"])), 64))
            ]),
            v("fieldset", Qa, [
              l(t(Z), {
                text: R.$t("mp_calculator_croatia.form.net_to_gross"),
                onClick: c[3] || (c[3] = (n) => j(t(M).NetToGross))
              }, null, 8, ["text"]),
              l(t(Z), {
                text: R.$t("mp_calculator_croatia.form.gross_to_net"),
                onClick: c[4] || (c[4] = (n) => j(t(M).GrossToNet))
              }, null, 8, ["text"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["p", "border", "shadow"]),
      t(h) ? (y(), G(t(X), {
        key: 0,
        margin: "none"
      })) : z("", !0),
      v("div", {
        ref_key: "calculationRef",
        ref: s
      }, [
        l(Ea, { result: _.value }, null, 8, ["result"])
      ], 512)
    ]));
  }
});
const _e = /* @__PURE__ */ I(Xa, [["__scopeId", "data-v-9470a5e0"]]);
class qa {
  async calculate(e) {
    return e.type === M.GrossToNet ? this.grossToNet(e) : this.netToGross(e);
  }
  async grossToNet(e) {
    const k = e.place.lowRate * 100, r = 7.5;
    return new Promise(async (h) => {
      const s = Math.min(e.amount, 57222) * 0.075, p = Math.min(e.amount, 57222) * (2.5 / 100), m = s + p, _ = Math.max(0, e.amount - m), u = _ * (k / 100), P = u, B = e.amount * (r / 100), j = e.amount + B, V = e.amount - m - P;
      h({
        net_amount: V,
        gross_1_amount: e.amount,
        pension_1_amount: s,
        pension_1_percent: 7.5,
        pension_2_amount: p,
        pension_2_percent: 2.5,
        gross_contribution_amount: m,
        taxable_amount: _,
        tax_amount: u,
        tax_percent: k,
        health_insurance_amount: B,
        health_insurance_percent: r,
        gross_2_amount: j
      });
    });
  }
  async netToGross(e) {
    const a = e.amount, o = e.place.lowRate * 100, b = r(), k = a * b;
    function r() {
      return (10 + 0.9 * o) / (90 - 0.9 * o) + 1;
    }
    return this.grossToNet({
      ...e,
      amount: k,
      type: M.GrossToNet
    });
  }
}
const ae = new qa(), ee = { class: "result__title" }, le = { class: "result__basic" }, te = { class: "result__highlight" }, oe = { class: "result__highlight" }, ue = { class: "result__detailed" }, ie = { class: "result__detailed-table result__detailed-table--no-scroll" }, re = /* @__PURE__ */ N({
  __name: "ServiceCalculation",
  props: {
    result: {}
  },
  setup(i) {
    const { isMobile: e } = U();
    return (a, o) => a.result ? (y(), G(t(F), {
      key: 0,
      class: "result",
      p: t(e) ? "unset" : "lg",
      border: !t(e),
      shadow: !t(e)
    }, {
      default: d(() => [
        v("div", ee, [
          l(t(K), { type: "h5" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_title")), 1)
            ]),
            _: 1
          }),
          l(t(K), { "no-margin": "" }, {
            default: d(() => [
              S($(a.$t("mp_calculator_croatia.result.details_warning")), 1)
            ]),
            _: 1
          })
        ]),
        v("div", le, [
          v("div", te, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_gross")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.gross_1_amount,
              as: "h4"
            }, null, 8, ["value"])
          ]),
          v("div", oe, [
            l(t(K), { "no-margin": "" }, {
              default: d(() => [
                S($(a.$t("mp_calculator_croatia.result.salary_net")) + ": ", 1)
              ]),
              _: 1
            }),
            l(T, {
              value: a.result.net_amount,
              as: "h4"
            }, null, 8, ["value"])
          ])
        ]),
        v("div", ue, [
          v("ul", ie, [
            l(g, {
              name: "(1) " + a.$t("mp_calculator_croatia.result.gross_amount"),
              value: a.result.gross_1_amount
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(2) " + a.$t("mp_calculator_croatia.result.pension_1"),
              description: a.$t("mp_calculator_croatia.result.pension_1_more"),
              percentage: a.result.pension_1_percent,
              value: a.result.pension_1_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(3) " + a.$t("mp_calculator_croatia.result.pension_2"),
              description: a.$t("mp_calculator_croatia.result.pension_2_more"),
              percentage: a.result.pension_2_percent,
              value: a.result.pension_2_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(4) " + a.$t("mp_calculator_croatia.result.gross_contribution"),
              value: a.result.gross_contribution_amount
            }, null, 8, ["name", "value"]),
            l(g, {
              name: "(5) " + a.$t("mp_calculator_croatia.result.tax_base"),
              description: a.$t("mp_calculator_croatia.result.taxable_amount_more"),
              value: a.result.taxable_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(6) " + a.$t("mp_calculator_croatia.result.tax"),
              description: a.$t("mp_calculator_croatia.result.tax_more"),
              percentage: a.result.tax_percent,
              value: a.result.tax_amount
            }, null, 8, ["name", "description", "percentage", "value"]),
            l(g, {
              name: "(9) " + a.$t("mp_calculator_croatia.result.health_insurance"),
              percentage: a.result.health_insurance_percent,
              value: a.result.health_insurance_amount
            }, null, 8, ["name", "percentage", "value"]),
            l(g, {
              name: "(10) " + a.$t("mp_calculator_croatia.result.total_expense") + " (1+9)",
              description: a.$t("mp_calculator_croatia.result.total_expense_more"),
              value: a.result.gross_2_amount
            }, null, 8, ["name", "description", "value"]),
            l(g, {
              name: "(11) " + a.$t("mp_calculator_croatia.result.amount_net"),
              value: a.result.net_amount
            }, null, 8, ["name", "value"])
          ])
        ]),
        z("", !0)
      ]),
      _: 1
    }, 8, ["p", "border", "shadow"])) : z("", !0);
  }
});
const ne = /* @__PURE__ */ I(re, [["__scopeId", "data-v-a90dfc51"]]), se = { class: "calc" }, ve = { class: "calc__form form" }, he = { class: "form__fieldset form__controls" }, be = /* @__PURE__ */ N({
  __name: "Service",
  props: {
    input: {}
  },
  emits: ["change"],
  async setup(i, { emit: e }) {
    var j, V;
    let a, o;
    const b = i, k = e, r = C();
    r.mergeLocaleMessage("hr", aa), r.mergeLocaleMessage("en", q);
    const { isMobile: h } = U(), s = D(null), p = ([a, o] = H(() => ea.getPlaces()), a = await a, o(), a), m = D(), _ = W({
      amount: ((j = b.input) == null ? void 0 : j.amount) ?? 5e3,
      place: p.find((x) => {
        var R, c;
        return x.value === ((c = (R = b.input) == null ? void 0 : R.place) == null ? void 0 : c.value);
      }) ?? p.find((x) => x.label === "Zagreb") ?? p[0],
      type: (V = b.input) == null ? void 0 : V.type
    }), u = O(() => ({
      amount: +_.amount,
      place: _.place,
      type: _.type ?? M.NetToGross
    }));
    function P(x) {
      return (x * 100).toFixed(2);
    }
    async function B(x) {
      x && (_.type = x), k("change", u.value), m.value = await ae.calculate(u.value), s.value && (await la(100), ta(s.value));
    }
    return Y(() => {
      _.type && B();
    }), (x, R) => (y(), L("section", se, [
      l(t(F), {
        class: "calc__card",
        p: t(h) ? "unset" : "lg",
        border: !t(h),
        shadow: !t(h)
      }, {
        default: d(() => [
          v("form", ve, [
            l(t(J), {
              modelValue: _.amount,
              "onUpdate:modelValue": R[0] || (R[0] = (c) => _.amount = c),
              label: x.$t("mp_calculator_croatia.form.amount"),
              min: "0"
            }, null, 8, ["modelValue", "label"]),
            l(t(Q), {
              modelValue: _.place,
              "onUpdate:modelValue": R[1] || (R[1] = (c) => _.place = c),
              options: t(p),
              "get-label": (c) => `${c.label} (${P(c.lowRate)}%)`,
              label: x.$t("mp_calculator_croatia.form.place"),
              "max-menu-height": 200
            }, null, 8, ["modelValue", "options", "get-label", "label"]),
            v("fieldset", he, [
              l(t(Z), {
                text: x.$t("mp_calculator_croatia.form.net_to_gross"),
                onClick: R[2] || (R[2] = (c) => B(t(M).NetToGross))
              }, null, 8, ["text"]),
              l(t(Z), {
                text: x.$t("mp_calculator_croatia.form.gross_to_net"),
                onClick: R[3] || (R[3] = (c) => B(t(M).GrossToNet))
              }, null, 8, ["text"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["p", "border", "shadow"]),
      t(h) ? (y(), G(t(X), {
        key: 0,
        margin: "none"
      })) : z("", !0),
      v("div", {
        ref_key: "calculationRef",
        ref: s
      }, [
        l(ne, { result: m.value }, null, 8, ["result"])
      ], 512)
    ]));
  }
});
const me = /* @__PURE__ */ I(be, [["__scopeId", "data-v-0739167b"]]);
export {
  _e as Author,
  pe as Salary,
  me as Service
};
